const INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES_INITIAL_STATE = {
  isLoading: false,
  error: undefined,
  data: [],
}

export default INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES_INITIAL_STATE
